<!-- eslint-disable vue/multi-word-component-names -->
<script>
export default {
  props: {
    value: null,
    defaultVal: null,
  },

  data() {
    return {
      firstVal: '',
      secondVal: '',
    };
  },
  methods: {
    validateOnChange: function (val) {
      const key = val.key;
      const keyCode = val.keyCode;

      const allowedKeys = [
        'Backspace', 'Escape', 'ArrowLeft', 'ArrowRight',
        'Delete', 'Tab', 'Home', 'End'
      ];

      const isNumber = keyCode >= 48 && keyCode <= 57;

      if (
        allowedKeys.includes(key) ||
        isNumber
      ) {
        return;
      } else {
        val.preventDefault();
      }
    },
    onChangeField: function (val, length, previousFieldRef, nextFieldRef) {
      if (val?.trim()?.length === length) {
        this.$refs?.[nextFieldRef]?.focus();
      } else if (val?.trim()?.length === 0) {
        this.$refs?.[previousFieldRef]?.focus();
      }
    },
    setCurrentValValue: function (firstVal, secondVal) {
      this.firstVal = firstVal;
      this.secondVal = secondVal;
    },
    setInitialVal: function () {
      this.setCurrentValValue(
        this.value.slice(0, 3),
        this.value.slice(3, 8),
      );
    },
  },
  computed: {
    plateNumber: function () {
      return `${this.firstVal}${this.secondVal}`;
    },
  },
  watch: {
    defaultVal: {
      handler(currentVal) {
        if (currentVal?.length && !this.plateNumber) {
          this.setCurrentValValue(
            currentVal.slice(0, 3),
            currentVal.slice(3, 8),
          );
        }
      },
      immediate: true,
    },
    plateNumber: function (currentVal) {
      if (currentVal.trim()) this.$emit('input', currentVal.trim());
    },
  },
};
</script>
<template>
  <v-row no-gutters class="currentVal-container">
    <v-col cols="2">
      <v-img :src="require('@/assets/images/flagPelak.jpg')"></v-img>
    </v-col>
    <v-col cols="9">
      <v-row no-gutters class="currentVal-container">
        <v-col cols="12">
          <v-text-field ref="lastField" dense outlined hide-details maxlength="3" placeholder="123" v-model="firstVal"
            @input="(val) => onChangeField(val, 3, 'firstField', 'secondField')"
            @keydown="validateOnChange"></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-text-field ref="secondField" dense outlined hide-details maxlength="5" placeholder="45678"
            v-model="secondVal" @input="(val) => onChangeField(val, 5, 'firstField', 'thirdField')"
            @keydown="validateOnChange"></v-text-field>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>
<style lang="scss">
.currentVal-container {
  flex-direction: row-reverse !important;
  gap: 0.5rem;

  & {
    input {
      text-align: center;
    }
  }
}
</style>
